import React, { useState, useEffect } from "react";
import FailedBid from "./FailedBid";
import axiosClient from "../../service/axios";
import { SyncOutlined } from "@ant-design/icons";
import Search from "../../components/search";

const FailedItem = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const declineHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosClient.get(
        "/lite/v2/api/admin/failed/orders/bids"
      );

      const responseData = response?.data?.data;
      // console.log(responseData, "response");
      setData(responseData);
      setLoading(false);
    } catch (error) {
      console.log("error is decline");
    }
  };

  useEffect(() => {
    declineHandler();
  }, []);

  const filteredData = data.filter((row) =>
    row?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <>
      <div>
        <Search placeholder="Find Any Order..." onChange={handleSearch} />
      </div>
      <div>
        {filteredData.length > 0 ? (
          filteredData.map((item, index) => (
            <FailedBid
              key={index}
              id={item.id}
              channel={item.channel}
              order_by={item.order_by}
              status={item.status}
              color={item.color}
              quipOrStock={item.quipOrStock}
              fone={item.fone}
              name={item.name}
              tym={item.tym}
              ops_status={item.ops_status}
              since={item.since}
            />
          ))
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            {loading ? <SyncOutlined spin /> : "Items Not Available"}
          </div>
        )}
      </div>
    </>
  );
};

export default FailedItem;
